/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_portfolio_builder_asset_list_ListAssetListsArgs = {
    include_archived?: boolean;
    organization: string;
    type?: b2b_v1_portfolio_builder_asset_list_ListAssetListsArgs.type;
};
export namespace b2b_v1_portfolio_builder_asset_list_ListAssetListsArgs {
    export enum type {
        PORTFOLIO_BUILDER = 'portfolio_builder',
        ASSET_CLASS = 'asset_class',
    }
}

